import { useTranslation } from 'react-i18next';

import "./ProjectVideos.scss"

const ProjectVideos = ({ videos }) => {

    const { t } = useTranslation();

    return (
        <div className='projectVideos'>
            <h2 className='projectVideos__title'>{t('project.titleVideos')}</h2>
            <div className='projectVideos__info'>
                {videos.map((singleVideo, keyVideo) => {
                    return (
                        <div className='projectVideos__singleVideo' key={keyVideo}>
                            <a href={singleVideo.linkYT} className="projectVideos__aVideo" target="_blank">
                                <p className='projectVideos__textVideo'>{singleVideo.textVideo}</p>
                            </a>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ProjectVideos;